// components/ui/Feedback/LoadingPlaceholder.jsx
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LoadingPlaceholder({ height = 200 }) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={height}>
      <CircularProgress />
    </Box>
  );
}